"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Service Management Public REST API
 * Public REST API for Jira Service Management
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-a295e7484152fa2365a7ce8735dc664cc7adfec0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonNodeToJSON = exports.JsonNodeFromJSONTyped = exports.JsonNodeFromJSON = exports.instanceOfJsonNode = exports.JsonNodeNumberTypeEnum = void 0;
/**
 * @export
 */
exports.JsonNodeNumberTypeEnum = {
    Int: 'INT',
    Long: 'LONG',
    BigInteger: 'BIG_INTEGER',
    Float: 'FLOAT',
    Double: 'DOUBLE',
    BigDecimal: 'BIG_DECIMAL'
};
/**
 * Check if a given object implements the JsonNode interface.
 */
function instanceOfJsonNode(value) {
    return true;
}
exports.instanceOfJsonNode = instanceOfJsonNode;
function JsonNodeFromJSON(json) {
    return JsonNodeFromJSONTyped(json, false);
}
exports.JsonNodeFromJSON = JsonNodeFromJSON;
function JsonNodeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'array': json['array'] == null ? undefined : json['array'],
        'bigDecimal': json['bigDecimal'] == null ? undefined : json['bigDecimal'],
        'bigInteger': json['bigInteger'] == null ? undefined : json['bigInteger'],
        'bigIntegerValue': json['bigIntegerValue'] == null ? undefined : json['bigIntegerValue'],
        'binary': json['binary'] == null ? undefined : json['binary'],
        'binaryValue': json['binaryValue'] == null ? undefined : json['binaryValue'],
        '_boolean': json['boolean'] == null ? undefined : json['boolean'],
        'booleanValue': json['booleanValue'] == null ? undefined : json['booleanValue'],
        'containerNode': json['containerNode'] == null ? undefined : json['containerNode'],
        'decimalValue': json['decimalValue'] == null ? undefined : json['decimalValue'],
        '_double': json['double'] == null ? undefined : json['double'],
        'doubleValue': json['doubleValue'] == null ? undefined : json['doubleValue'],
        'elements': json['elements'] == null ? undefined : json['elements'],
        'fieldNames': json['fieldNames'] == null ? undefined : json['fieldNames'],
        'fields': json['fields'] == null ? undefined : json['fields'],
        'floatingPointNumber': json['floatingPointNumber'] == null ? undefined : json['floatingPointNumber'],
        '_int': json['int'] == null ? undefined : json['int'],
        'intValue': json['intValue'] == null ? undefined : json['intValue'],
        'integralNumber': json['integralNumber'] == null ? undefined : json['integralNumber'],
        '_long': json['long'] == null ? undefined : json['long'],
        'longValue': json['longValue'] == null ? undefined : json['longValue'],
        'missingNode': json['missingNode'] == null ? undefined : json['missingNode'],
        '_null': json['null'] == null ? undefined : json['null'],
        'number': json['number'] == null ? undefined : json['number'],
        'numberType': json['numberType'] == null ? undefined : json['numberType'],
        'numberValue': json['numberValue'] == null ? undefined : json['numberValue'],
        'object': json['object'] == null ? undefined : json['object'],
        'pojo': json['pojo'] == null ? undefined : json['pojo'],
        'textValue': json['textValue'] == null ? undefined : json['textValue'],
        'textual': json['textual'] == null ? undefined : json['textual'],
        'valueAsBoolean': json['valueAsBoolean'] == null ? undefined : json['valueAsBoolean'],
        'valueAsDouble': json['valueAsDouble'] == null ? undefined : json['valueAsDouble'],
        'valueAsInt': json['valueAsInt'] == null ? undefined : json['valueAsInt'],
        'valueAsLong': json['valueAsLong'] == null ? undefined : json['valueAsLong'],
        'valueAsText': json['valueAsText'] == null ? undefined : json['valueAsText'],
        'valueNode': json['valueNode'] == null ? undefined : json['valueNode'],
    };
}
exports.JsonNodeFromJSONTyped = JsonNodeFromJSONTyped;
function JsonNodeToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'array': value['array'],
        'bigDecimal': value['bigDecimal'],
        'bigInteger': value['bigInteger'],
        'bigIntegerValue': value['bigIntegerValue'],
        'binary': value['binary'],
        'binaryValue': value['binaryValue'],
        'boolean': value['_boolean'],
        'booleanValue': value['booleanValue'],
        'containerNode': value['containerNode'],
        'decimalValue': value['decimalValue'],
        'double': value['_double'],
        'doubleValue': value['doubleValue'],
        'elements': value['elements'],
        'fieldNames': value['fieldNames'],
        'fields': value['fields'],
        'floatingPointNumber': value['floatingPointNumber'],
        'int': value['_int'],
        'intValue': value['intValue'],
        'integralNumber': value['integralNumber'],
        'long': value['_long'],
        'longValue': value['longValue'],
        'missingNode': value['missingNode'],
        'null': value['_null'],
        'number': value['number'],
        'numberType': value['numberType'],
        'numberValue': value['numberValue'],
        'object': value['object'],
        'pojo': value['pojo'],
        'textValue': value['textValue'],
        'textual': value['textual'],
        'valueAsBoolean': value['valueAsBoolean'],
        'valueAsDouble': value['valueAsDouble'],
        'valueAsInt': value['valueAsInt'],
        'valueAsLong': value['valueAsLong'],
        'valueAsText': value['valueAsText'],
        'valueNode': value['valueNode'],
    };
}
exports.JsonNodeToJSON = JsonNodeToJSON;
//# sourceMappingURL=JsonNode.js.map